import React from "react";
import { Badge, Divider, Form } from "antd";
import { downloadImg } from "@/utils/constant";
import * as DICT from "@/utils/dict";
import CONST from "@/dataSource/CONST";
import defaultImg from "@/assets/images/pic-error.png";
import { ImageList } from "@/components/Img";
import intl from "react-intl-universal";
import styles from "./baseStatus.module.less";
import PropIcon from "@/components/Icon/PropIcon";
import classnames from "classnames";
import Tag from "@/components/Tag";
import DeviceInfoModel from "../../deviceInfo";

class BaseStatus extends React.Component {
  state = {
    deviceInfoVisible: false,
  };
  componentDidMount() {}

  deviceInfoChange = () => {
    this.setState({ deviceInfoVisible: !this.state.deviceInfoVisible });
  };

  render() {
    const { deviceInfo, short, showDeviceInfo } = this.props;
    const { deviceInfoVisible } = this.state;

    if (!(deviceInfo && deviceInfo.id && deviceInfo.id.length > 0)) return ``;
    let detail = deviceInfo;
    let imageListData = [];
    if (detail.image1)
      imageListData.push({
        src: detail.image1 ? downloadImg + detail.image1 : defaultImg,
      });
    if (detail.image2)
      imageListData.push({
        src: detail.image2 ? downloadImg + detail.image2 : defaultImg,
      });
    if (detail.image3)
      imageListData.push({
        src: detail.image3 ? downloadImg + detail.image3 : defaultImg,
      });
    if (detail.image4)
      imageListData.push({
        src: detail.image4 ? downloadImg + detail.image4 : defaultImg,
      });

    let getRow = (name, text) => (
      <div className={styles.row}>
        <span className={styles.name}>{name}</span>
        <div className={styles.text}>{text}</div>
      </div>
    );

    return (
      <div className={styles.deviceInfoMain}>
        {deviceInfoVisible ? (
          <DeviceInfoModel
            visible={deviceInfoVisible}
            deviceInfo={deviceInfo}
            onClose={this.deviceInfoChange}
          />
        ) : (
          ``
        )}
        <div className={styles.row}>
          <div
            className={classnames(styles.imageDiv, {
              [styles.click]: showDeviceInfo,
            })}
            onClick={(e) => (showDeviceInfo ? this.deviceInfoChange() : ``)}
          >
            <img
              className={styles.image}
              title={detail.productName}
              alt=""
              src={downloadImg + detail.productImage1}
            />
            <div className={styles.nameDiv}>
              <div className={styles.row}>{detail.name}</div>
              <div className={styles.row}>{detail.sn}</div>
              {detail.deviceState || detail.armState || detail.dataState ? (
                <div className={styles.row}>
                  {detail.deviceState ? (
                    <Tag className={styles.tag} color={detail.deviceState}>
                      {DICT.getValue("DEVICE_STATE_TYPE", detail.deviceState)}
                    </Tag>
                  ) : (
                    ``
                  )}
                  {detail.armState ? (
                    <Tag className={styles.tag} color={detail.armState}>
                      {DICT.getValue("ARM_STATE", detail.armState)}
                    </Tag>
                  ) : (
                    ``
                  )}
                  {detail.dataState ? (
                    <Tag className={styles.tag} color={detail.dataState}>
                      {detail.dataState === `Enable` ? `启用` : `禁用`}
                    </Tag>
                  ) : (
                    ``
                  )}
                </div>
              ) : (
                ``
              )}
            </div>
          </div>
        </div>
        {detail.unitName ? getRow(`产品类型:`, detail.productName) : ``}
        {detail.unitName ? getRow(`所属单位:`, detail.unitName) : ``}
        {detail.address ? getRow(`详细地址:`, detail.address) : ``}
        {detail.installLocation
          ? getRow(`安装位置:`, detail.installLocation)
          : ``}
        {short ? (
          ``
        ) : (
          <React.Fragment>
            {detail.realName
              ? getRow(`报装人员:`, `${detail.realName}(${detail.userName})`)
              : ``}
            {detail.createdTime ? getRow(`报装时间:`, detail.createdTime) : ``}
            {detail.heartBeatTime
              ? getRow(`最后通信:`, detail.heartBeatTime)
              : ``}
            {imageListData && imageListData.length > 0 ? (
              <div className={styles.imgRow}>
                <span className={styles.name}>安装照片:</span>
                <ImageList
                  className={styles.imgList}
                  imageInfoList={imageListData}
                  showImage={(imageList, onImgClick) => {
                    if (!(imageList && imageList.length > 0)) return "";
                    return imageList.map((item, index) => {
                      return (
                        <img
                          className={styles.image}
                          src={item.src}
                          alt=""
                          onClick={(e) => onImgClick(index)}
                        />
                      );
                    });
                  }}
                />
              </div>
            ) : (
              ``
            )}
          </React.Fragment>
        )}
      </div>
    );
  }
}

export default BaseStatus;
